import { useAuth } from 'Components/Auth'
import { useUserQuery } from 'Queries/Users'

export const useSuperAdmin = () => {
  const { id: userId } = useAuth()
  const { data: user = {} } = useUserQuery(userId)

  return user.statuses?.includes('superadmin')
}
